export default "__VITE_ASSET__Dr_o5Jgy__"